import dayjs from "dayjs";

import {
  formatWearableObservationValue,
  getWearableObservationLabel,
} from "@/utils/wearableObservationFormat";

import { extractObservationIdFromEntry } from "./wearableObservationActiveStatus";

export interface WearableRemovableItem {
  id: string;
  label: string;
  hint?: string;
  /** Horário de envio (issued) para ordenação decrescente. */
  sortKey?: number;
}

/** Lista de Observations removíveis para o dialog (rótulo + horário de envio). */
export function buildWearableRemovableItems(
  entries: unknown[],
): WearableRemovableItem[] {
  const items: WearableRemovableItem[] = [];

  for (const entry of entries) {
    const id = extractObservationIdFromEntry(entry);
    if (!id) continue;

    const resource = (entry as { resource?: unknown })?.resource;
    if (!resource || typeof resource !== "object") continue;

    const issuedRaw = (resource as { issued?: string }).issued;
    const issuedAt =
      issuedRaw && dayjs(issuedRaw).isValid() ? dayjs(issuedRaw).valueOf() : 0;
    const issuedLabel = issuedAt ? dayjs(issuedRaw).format("HH:mm") : "";
    const metricLabel = getWearableObservationLabel(resource);
    const value = formatWearableObservationValue(resource);

    items.push({
      id,
      label: issuedLabel ? `${issuedLabel} · ${metricLabel}` : metricLabel,
      hint: value && value !== "-" ? value : undefined,
      sortKey: issuedAt,
    });
  }

  return items.sort((a, b) => (b.sortKey ?? 0) - (a.sortKey ?? 0));
}
